const EVENTS = {
  PWA_BOTTOMBAR_CLICK: "PwaBottombarClick",
  PWA_BOTTOMBAR_NUDGE_ACTION: "PwaBottombarNudgeAction",
  PWA_SHARE_NUDGE_ACTION: "PwaShareNudgeAction",
  SHARE_BUTTON: "ShareButton",
  VIDEO_PLAY: "VideoPlay",
  VIDEO_PLAY_START: "VideoPlayStartEvent",
  PWA_STATIC_INSTALL_VIEW: "PWASaticInstallView",
  PWA_STATIC_INSTALL_CLICK: "PWASaticInstallClick",
  SSR_EVENTS: "SsrEvents",
  BOT_USER_EVENTS: "botUserEvents",

  // Payments
  PAYMENT_EVENTS: {
    RECHARGE_WALLET: "rechargeWallet",
    RECHARGE_STATUS: "rechargeStatus",
    SELECT_PAYMENT_METHOD: "selectPaymentMethod",
    OPEN_PAYMENT_PAGE: "openPaymentPage",
    PAYMENT_INITIATION_EVENT: "paymentInitiationEvent",
    OPEN_RECHARGE_OPTIONS: "openRechargeOptions",
  },

  MFC_EVENTS: {
    MFC_JOURNEY_ZERO_STATE_PAGE_OPENED: "mfcJourneyZeroStatePageOpened",
    MFC_SELECT_KNOW_MORE_CLICKED: "mfcSelectKnowMoreClicked",
    MFC_SELECT_APPLY_NOW_CLICKED: "mfcSelectApplyNowClicked",
    LIVE_ACCESS_APPLY_NOW_CLICKED: "liveAccessApplyNowClicked",
    CREATOR_JOURNEY_FLOW_EVENTS: "creatorJourneyFlowEvents",
  },
};

export default EVENTS;
